import { Typography } from '@trellis/roots/typography'
import { TriangleAlert } from 'lucide-react'

import { useReminderDivertNotice } from '@/hooks/useEmailDivertNotice'
import { cn } from '@/lib/utils'

import { AMBER_NOTICE_CLASSES } from './reminders.constants'

/** Non-production banner on every reminder screen saying where reminder email really goes. */
export function ReminderDivertBanner({ className }: { className?: string }) {
  const message = useReminderDivertNotice()
  if (!message) return null

  return (
    <div
      role="note"
      className={cn('flex gap-2 rounded-lg border p-3', AMBER_NOTICE_CLASSES, className)}
    >
      <TriangleAlert className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <Typography variant="body-sm" className="text-inherit">
        {message}
      </Typography>
    </div>
  )
}
